var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatWeDo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-questions",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-questions:not(.animated) .animable {opacity: 0;}svg#freepik_stories-questions.animated #freepik--background-complete--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-questions.animated #freepik--Floor--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-questions.animated #freepik--Shadow--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-questions.animated #freepik--Plant--inject-2 {animation: 1.7s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-questions.animated #freepik--question-mark--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-questions.animated #freepik--Character--inject-2 {animation: 0.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-questions.animated #freepik--speech-bubble--inject-2 {animation: 1.9s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "250.135px 197.77px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el7ewj8qccys4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.62,
    y: 121.17,
    width: 166.63,
    height: 7.31,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "139.935px 124.825px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el8la48s3lsbv"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 128.48,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "210.255px 140.565px"
    },
    id: "elf1kdhxgvvdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 128.48,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "210.255px 132.215px"
    },
    id: "el6c10065zw6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.96,
    y: 128.48,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "69.615px 140.565px"
    },
    id: "eln1syiyufywl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.96,
    y: 128.48,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "69.615px 132.215px"
    },
    id: "el8nqi7pa5tj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eludxwwfxiizq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 92.02,
    width: 46.57,
    height: 11.73,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "186.285px 97.885px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elpihm7ooxfp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3nnluejx8ra"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.73,
    y: 68.8,
    width: 5.12,
    height: 11.73,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "186.29px 74.665px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elar3olaq0e6u"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1k20amt4mpq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.34,
    y: 78.87,
    width: 1.9,
    height: 11.73,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "186.29px 84.735px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elnai5jd6i1k8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltxoe85lo51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 105.91,
    width: 5.12,
    height: 13.19,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "185.56px 112.505px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elu00k4x3jm1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elei096dce2e8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.16,
    y: 89.91,
    width: 54.33,
    height: 8.2,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "176.325px 94.01px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el893jc27eoq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9wi93wfz8sr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.91,
    y: 79.94,
    width: 20.89,
    height: 4.92,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "176.355px 82.4px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elht5s46ln99c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely5g22xq01v"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.95,
    y: 95.07,
    width: 54.33,
    height: 8.2,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "136.115px 99.17px",
      transform: "rotate(135.33deg)"
    },
    className: "animable",
    id: "elhnkra9r88ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0gvjetus0lq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.83,
    y: 99.48,
    width: 20.89,
    height: 4.92,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "133.275px 101.94px",
      transform: "rotate(135.33deg)"
    },
    className: "animable",
    id: "elzia7wj1smg8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcn41dr0y6vv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.64,
    y: 93.59,
    width: 41.26,
    height: 13.92,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "165.27px 100.55px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "eloaanf2qxd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvt55mrr1fms"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.35,
    y: 107.92,
    width: 3.85,
    height: 13.92,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "165.275px 114.88px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elk4qhxwaqpdg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9cpfrnv3y7b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.53,
    y: 102.73,
    width: 1.49,
    height: 13.92,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "165.275px 109.69px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el6wmatg38i6x"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el08q19yovo4fb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.57,
    y: 96.98,
    width: 38.78,
    height: 9.61,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "196.96px 101.785px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el7ixxrjuijqf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ele5vwcg7nhfn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.15,
    y: 110.45,
    width: 3.61,
    height: 9.61,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "196.955px 115.255px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elw0fxje37ml"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc49pcifhqdf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.15,
    y: 87.39,
    width: 3.61,
    height: 9.61,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "196.955px 92.195px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el8mj7as3lnxc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el745vn2z3y54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.26,
    y: 92.38,
    width: 1.4,
    height: 9.61,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "196.96px 97.185px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elnq3sd1h44a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,71.49c8.2,8,9.58,20.46,7.85,31.34,0,.24-.43.18-.43-.06,0-2.47.08-4.93.07-7.37,0-.12-.08-.22-.13-.33a16.53,16.53,0,0,1-5.33-5.73c-1.37-2.69-1.91-5.73-2.95-8.55-.1-.27.19-.19.37-.05,5,3.68,6.58,7.64,8,12.93a44.44,44.44,0,0,0-.87-8.24A28.09,28.09,0,0,0,90.1,71.71.16.16,0,0,1,90.32,71.49Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "94.1033px 87.2246px"
    },
    id: "eleriaj318q7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.78,72.43c-1.42,0-2.3,2.3-3.4,3a1.06,1.06,0,0,1-1.56-.25c-1.09-1.52.41-3.39,1.81-4.44A15.39,15.39,0,0,1,82.71,72a1,1,0,0,1-1.32-.79c-.48-2.07,2.12-3,3.91-3-.87-.6-3.35-2.23-2-3s4.25,1.53,5.19,2.3c1.4,1.13,3.06,2.83,3.13,4.6C91.67,74.13,89.86,72.86,88.78,72.43Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "86.4765px 70.3608px"
    },
    id: "elgoeuh3lxi7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18,72.78c-1.8-.83-5.27.36-5.56-.33-.6-1.39,2.17-2.34,3.67-2.53-1.38-.37-4-1-3.94-2.29.1-1.62,4.05-.23,6.05,1.3,2.51,1.93,2.5,3.8,2.08,4.17C90.91,73.61,89.48,72.91,89.18,72.78Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "87.5197px 70.0945px"
    },
    id: "elch4ajn7sqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,70.7c-8.5,7.71-10.35,20.07-9,31,0,.25.42.2.43,0,.09-2.47.11-4.93.21-7.37l.14-.33a16.4,16.4,0,0,0,5.54-5.51c1.48-2.64,2.13-5.66,3.28-8.43.11-.27-.18-.2-.37-.07-5.13,3.49-6.87,7.39-8.5,12.62a44.3,44.3,0,0,1,1.18-8.2,28.09,28.09,0,0,1,7.34-13.46A.15.15,0,0,0,109,70.7Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "104.612px 86.259px"
    },
    id: "elfq1wo0sivb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5,71.69c1.41.1,2.21,2.39,3.28,3.09a1.06,1.06,0,0,0,1.57-.19c1.15-1.48-.28-3.41-1.64-4.51a15.82,15.82,0,0,0,2.87,1.46,1,1,0,0,0,1.35-.74c.55-2.06-2-3.08-3.79-3.19.88-.57,3.42-2.11,2.14-3S112,66,111,66.75c-1.44,1.08-3.16,2.71-3.29,4.47C107.55,73.28,109.4,72.08,110.5,71.69Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "112.853px 69.7256px"
    },
    id: "elp7hbslmbmbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.08,72c1.84-.75,5.25.56,5.57-.11.65-1.36-2.08-2.42-3.56-2.66,1.39-.32,4-.82,4-2.15,0-1.62-4-.38-6.09,1.08-2.58,1.83-2.64,3.69-2.24,4.08C108.32,72.79,109.78,72.15,110.08,72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "111.834px 69.3874px"
    },
    id: "elz83g1ibxtqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,91.07a82,82,0,0,1-2.64,12.19.3.3,0,0,1-.59-.12c.56-3.76,1.58-7.45,2.13-11.2a56.16,56.16,0,0,0,.66-11.51c-.36-6.33-2.08-13.07-6.21-18-.09-.12.1-.29.19-.18,8.28,9.65,7,21.48,7,22.54,1.17-4,2.38-8.57,6.81-12.64.19-.18.34-.09.31.21-.79,7.4-2.85,11.27-7.15,15.23C100.64,88.74,100.49,89.91,100.3,91.07Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "100.795px 82.8575px"
    },
    id: "eliiud3ogym7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,63.52c-1.49-.66-3.54,1.23-5,1.36a1.22,1.22,0,0,1-1.49-1c-.37-2.12,2.13-3.32,4.11-3.7-1.25-.08-2.48.26-3.71-.07a1.18,1.18,0,0,1-1-1.49c.55-2.39,3.71-2,5.59-1.19-.6-1-2.35-4-.58-4.17s3.64,3.72,4.23,5c.88,1.88,1.76,4.47.93,6.34C95.72,66.74,94.48,64.51,93.57,63.52Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "91.7095px 59.3762px"
    },
    id: "elmt1zbxc154",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.82,64.08c-1.46-1.75-5.65-2.27-5.61-3.13.08-1.74,3.43-1.34,5.08-.78-1.24-1.08-3.68-3-2.93-4.36.92-1.63,4.31,1.8,5.62,4.4,1.64,3.27.68,5.19.06,5.37C95.19,65.82,94.06,64.38,93.82,64.08Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "92.5492px 60.4971px"
    },
    id: "eldw0oqt4woxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75,93.29l3.65,27.88H87.19c.46-2.47,4.59-27.91,4.59-27.91Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "98.295px 107.215px"
    },
    id: "el76cembt64tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,100.43a20.23,20.23,0,0,1,3.24-7.13q2.19-3,7.06-4.36c1-.3,2.17-.62,3.58-1a26.4,26.4,0,0,0,4.24-1.42,13.81,13.81,0,0,0,3.81-2.43,7.53,7.53,0,0,0,2.29-3.89,7.06,7.06,0,0,0,.11-3.31,7.44,7.44,0,0,0-1.2-2.74,7.65,7.65,0,0,0-2.24-2.06,10.11,10.11,0,0,0-2.9-1.22A8.88,8.88,0,0,0,385,70.7a12.16,12.16,0,0,0-3.16.92,13.72,13.72,0,0,0-2.76,1.65,25.91,25.91,0,0,0-2.25,1.92l-6.1-7a17,17,0,0,1,4.1-3.94,18.45,18.45,0,0,1,5-2.39,20.31,20.31,0,0,1,5.58-.85,22,22,0,0,1,5.79.69,23.08,23.08,0,0,1,6.13,2.53,16.66,16.66,0,0,1,4.9,4.4,15.79,15.79,0,0,1,2.76,6.25,17.44,17.44,0,0,1-.34,8,16.89,16.89,0,0,1-1.84,4.64,13.79,13.79,0,0,1-2.78,3.32,16.83,16.83,0,0,1-3.57,2.35,32.52,32.52,0,0,1-4.31,1.71c-1.31.4-2.6.76-3.89,1.1a20.91,20.91,0,0,0-3.62,1.3,10.4,10.4,0,0,0-3,2.06,7.18,7.18,0,0,0-1.8,3.38Zm-4.81,19.83,2.95-11.72,9.43,2.37-2.95,11.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "385.551px 91.8189px"
    },
    id: "elg6nyxcnl94r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.08,317.78a14.89,14.89,0,0,1,.16,5.77A9.46,9.46,0,0,1,70,328.73c-.56.51-1.25,1.11-2.07,1.79a18.94,18.94,0,0,0-2.35,2.31,10.09,10.09,0,0,0-1.75,2.84,5.57,5.57,0,0,0-.26,3.32,5.36,5.36,0,0,0,1,2.24,5.57,5.57,0,0,0,1.68,1.43,5.71,5.71,0,0,0,2.15.63,7.5,7.5,0,0,0,2.32-.12,6.64,6.64,0,0,0,2.43-1,8.79,8.79,0,0,0,1.8-1.63,10.48,10.48,0,0,0,1.3-2,17.12,17.12,0,0,0,.87-2l6.3,2.64a12.6,12.6,0,0,1-1.46,3.94,13.45,13.45,0,0,1-2.56,3.21,14.55,14.55,0,0,1-3.43,2.37,16.4,16.4,0,0,1-4.06,1.41,17,17,0,0,1-4.88.31,12.32,12.32,0,0,1-4.67-1.33,11.77,11.77,0,0,1-3.86-3.26,12.91,12.91,0,0,1-2.35-5.41,12.24,12.24,0,0,1-.28-3.67,10,10,0,0,1,.77-3.1,11.83,11.83,0,0,1,1.61-2.71,23,23,0,0,1,2.3-2.54c.74-.68,1.48-1.34,2.23-2a15.83,15.83,0,0,0,2-2A7.54,7.54,0,0,0,66,322.07a5.25,5.25,0,0,0,.1-2.83Zm-3.22-14.71,1.83,8.73-7,1.47-1.83-8.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "69.6279px 326.773px"
    },
    id: "el22vgb1cfo4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,228.55a15,15,0,0,1,2.55,5.18,9.48,9.48,0,0,1-.83,6.07c-.29.7-.67,1.53-1.13,2.49a18.21,18.21,0,0,0-1.18,3.08,10.07,10.07,0,0,0-.41,3.31,5.66,5.66,0,0,0,1.14,3.13,5.24,5.24,0,0,0,1.84,1.61,5.5,5.5,0,0,0,2.13.6,5.56,5.56,0,0,0,2.22-.31,7.73,7.73,0,0,0,2.05-1.08,6.48,6.48,0,0,0,1.79-1.92,8.64,8.64,0,0,0,1-2.24,10.94,10.94,0,0,0,.35-2.35,19,19,0,0,0,0-2.17l6.82-.22a12.37,12.37,0,0,1,.32,4.18,13.74,13.74,0,0,1-1,4,14.9,14.9,0,0,1-2.14,3.58,16.5,16.5,0,0,1-3.1,3,16.94,16.94,0,0,1-4.32,2.31,12.36,12.36,0,0,1-4.8.73,11.85,11.85,0,0,1-4.86-1.35,13,13,0,0,1-4.39-3.95,12.27,12.27,0,0,1-1.78-3.22,9.9,9.9,0,0,1-.59-3.14,11.94,11.94,0,0,1,.33-3.14,24,24,0,0,1,1.05-3.26c.39-.93.78-1.84,1.2-2.73a15,15,0,0,0,1-2.67,7.73,7.73,0,0,0,.22-2.65,5.26,5.26,0,0,0-1.09-2.61Zm-9-12,5.29,7.17-5.77,4.26-5.29-7.17Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "389.972px 239.047px"
    },
    id: "el1cv8x7ueozh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.84,210.51a16.27,16.27,0,0,1,1.14-6.25,10.32,10.32,0,0,1,4.68-4.83c.71-.43,1.59-.91,2.63-1.46a20.61,20.61,0,0,0,3-1.95,10.78,10.78,0,0,0,2.52-2.66,6.12,6.12,0,0,0,1-3.52,5.78,5.78,0,0,0-2.06-4.54,6.09,6.09,0,0,0-2.16-1.17,8.39,8.39,0,0,0-2.52-.39,7.41,7.41,0,0,0-2.84.53,10.15,10.15,0,0,0-2.31,1.35,11.17,11.17,0,0,0-1.85,1.85,19.81,19.81,0,0,0-1.38,1.95l-6.18-4.26a13.9,13.9,0,0,1,2.45-3.91,15.22,15.22,0,0,1,3.48-2.87,16.54,16.54,0,0,1,4.23-1.78,18.2,18.2,0,0,1,4.68-.6,18.64,18.64,0,0,1,5.33.78,13.47,13.47,0,0,1,4.72,2.49,13,13,0,0,1,3.41,4.36A14.35,14.35,0,0,1,444.2,190a13.91,13.91,0,0,1-.53,4,11.43,11.43,0,0,1-1.53,3.16,13.14,13.14,0,0,1-2.34,2.55,26.21,26.21,0,0,1-3.06,2.2c-.94.57-1.89,1.12-2.84,1.64a17.22,17.22,0,0,0-2.59,1.74,8.3,8.3,0,0,0-1.91,2.2,5.73,5.73,0,0,0-.75,3Zm.14,16.54v-9.8h7.88v9.8Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "429.356px 201.525px"
    },
    id: "el9wm5q4s75pm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,267.32a16.32,16.32,0,0,1-.18-6.35,10.31,10.31,0,0,1,3.58-5.69c.61-.57,1.36-1.22,2.27-2a22.84,22.84,0,0,0,2.58-2.54,11.34,11.34,0,0,0,1.91-3.13,6.1,6.1,0,0,0,.28-3.65,5.85,5.85,0,0,0-1.1-2.46A6,6,0,0,0,181.8,240a6.12,6.12,0,0,0-2.36-.7,8.63,8.63,0,0,0-2.54.14,7.46,7.46,0,0,0-2.67,1.11,10.07,10.07,0,0,0-2,1.8,11.56,11.56,0,0,0-1.42,2.19,19.49,19.49,0,0,0-1,2.2L163,243.82a13.88,13.88,0,0,1,1.59-4.33,14.77,14.77,0,0,1,2.81-3.53,16.12,16.12,0,0,1,3.76-2.62,18.71,18.71,0,0,1,4.46-1.56,18.92,18.92,0,0,1,5.37-.34,13.58,13.58,0,0,1,5.13,1.45,12.79,12.79,0,0,1,4.24,3.57,15.71,15.71,0,0,1,2.92,10,11.24,11.24,0,0,1-.84,3.4,13.27,13.27,0,0,1-1.76,3,27.76,27.76,0,0,1-2.53,2.79c-.81.75-1.62,1.48-2.44,2.18a17.63,17.63,0,0,0-2.18,2.24,8.69,8.69,0,0,0-1.42,2.55,5.88,5.88,0,0,0-.1,3.11Zm3.57,16.15-2-9.58,7.71-1.64,2,9.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.151px 257.425px"
    },
    id: "eljzk8r80u80s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,344.89l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5L428,334.14c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.14,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5l0,11.19v.45h-.45c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.145px 339.27px"
    },
    id: "elj4m6tj75k0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,359l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5-13.24-.06c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.51v.5L456.49,359v.45H456c-2.23,0-4.46,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "442.92px 353.38px"
    },
    id: "elmpsqj2rwtxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,359l13.36-.28,6.58-.11c2.18-.05,4.36,0,6.54-.06l-.44.45L426,347.81l.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54Zm0,0-.14-5.54c-.05-1.86-.11-3.75-.13-5.65v-.27H400c4.41-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5L427,359v.45h-.44c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "413.365px 353.38px"
    },
    id: "elqsew11a1v5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,359l13.35-.28,6.58-.11c2.19-.05,4.37,0,6.55-.06l-.45.45-.05-11.19.5.5L72,348.25c-4.42,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.15-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.28c4.41-.05,8.82-.16,13.24-.17l13.24-.06h.5v.5L85.65,359v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "72.08px 353.38px"
    },
    id: "elsuqbwnya3nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,47.77l13.35-.28,6.58-.12c2.19,0,4.37,0,6.55,0l-.45.45-.05-11.19.5.49L72,37c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.76-.13-5.65v-.27h.28c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.23,0-4.47,0-6.7-.05L71.85,48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "72.08px 42.16px"
    },
    id: "elarumdqkk7cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,61.88l13.35-.28,6.58-.12c2.19,0,4.36,0,6.55,0l-.45.45,0-11.19.5.49L57.2,51.12C52.78,51.12,48.37,51,44,51l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.76-.13-5.65v-.27H44c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.24,0-4.47,0-6.7,0l-6.66-.12Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "57.35px 56.27px"
    },
    id: "el4di2jrla05y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,47.78l13.36-.28,6.58-.11c2.19,0,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5L442.8,37c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.15,13.24-.16L456,36.09h.51v.5l-.05,11.19v.45H456c-2.23,0-4.46,0-6.69,0l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "442.9px 42.16px"
    },
    id: "elnbnb4n7qqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,192.83l-13.35.28-6.58.11c-2.19.05-4.37,0-6.55.06l.45-.45.05,11.19-.5-.5,13.24.07c4.42,0,8.83.11,13.24.16l-.27.27c0-1.83.09-3.67.13-5.53Zm0,0,.15,5.54c0,1.87.11,3.75.13,5.65v.27h-.28c-4.41,0-8.82.15-13.24.16l-13.24.06h-.5V204l.06-11.19v-.45h.44c2.23,0,4.47,0,6.7.05l6.66.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "272.86px 198.435px"
    },
    id: "elwg2anwvmu6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,178.72l-13.35.28-6.58.11c-2.19,0-4.37,0-6.55.06l.45-.45.05,11.19-.5-.5,13.24.07c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53Zm0,0,.14,5.54c.05,1.87.12,3.75.13,5.65v.27h-.28c-4.41.05-8.83.15-13.24.16l-13.24.06h-.5v-.5l.06-11.19v-.45H245c2.23,0,4.47,0,6.7.05l6.66.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "258.08px 184.33px"
    },
    id: "el5cvv83o41eb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 409.52px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.37 409.52 91.28 409.28 144.19 409.19 250 409.02 355.81 409.19 408.72 409.28 461.63 409.52 408.72 409.77 355.81 409.86 250 410.02 144.19 409.86 91.28 409.77 38.37 409.52",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 409.52px"
    },
    id: "elr4iz0mo49x",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 443.64px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 443.64,
    rx: 180.39,
    ry: 17.56,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 443.64px"
    },
    id: "eleltlb5jaxqf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "392.975px 338.174px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,299.49c-3.8-3.72-8.71-8.22-14.52-6.61-5.46,1.51-7.55,7.47-8.53,12.44-1.26,6.41-2.24,12.87-3.26,19.32s-2,13-2.93,19.55q-.8,5.52-1.56,11.05-.39,2.76-.77,5.52c-.25,1.81-.55,3.62-.65,5.44,0,.58.88.66,1,.11.71-3.07,1-6.27,1.45-9.38s.91-6.28,1.36-9.41c.91-6.23,1.86-12.45,2.79-18.68s1.91-12.44,2.91-18.66c.84-5.28,1.24-11.83,5.91-15.31a9.07,9.07,0,0,1,8.75-.82c3.07,1.18,5.53,3.38,7.94,5.56C427,299.68,427.1,299.57,427,299.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.911px 329.613px"
    },
    id: "el7ikwmo9jcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.83,295.69s-7.77-2.79-11.6,2.87.75,20.08,36.1,28.21a99.63,99.63,0,0,0-8.5-31.95C430.25,278.29,416.74,284.55,421.83,295.69Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "427.72px 305.741px"
    },
    id: "elt7q8v4ypd6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3,324.41a27.27,27.27,0,0,0-1.78-2.86c-.59-.91-1.19-1.82-1.79-2.72-.45-.68-.92-1.36-1.38-2,0-.16,0-.33.06-.5l.12-.92c.09-.66.19-1.33.28-2s.21-1.31.34-2a10.28,10.28,0,0,1,.46-2.08c0-.11-.14-.16-.15,0a7.9,7.9,0,0,1-.32,1.18l-.24.89c-.17.67-.33,1.34-.48,2s-.26,1.25-.37,1.87c-.05.31-.09.61-.13.91-.63-.9-1.28-1.79-1.94-2.66-1.88-2.47-3.86-4.85-5.92-7.18,0,0,0,0,0-.06.19-3.71.1-7.39.92-11,0-.1-.12-.16-.15-.06a38.16,38.16,0,0,0-1.32,10.57c-.73-.82-1.48-1.64-2.23-2.45-1.73-1.85-3.48-3.68-5.27-5.46-.07-.07-.19,0-.12.11,3,3.21,5.81,6.55,8.57,9.95a60.74,60.74,0,0,0-6.47.24c-2.39.17-4.77.48-7.15.81-.11,0-.08.17,0,.16a63.12,63.12,0,0,1,7.14-.64c2.31-.1,4.6,0,6.91,0q2.24,2.76,4.41,5.58H436c-.54,0-1.08,0-1.62,0-1.08,0-2.15.1-3.22.19a47.83,47.83,0,0,0-6.53,1,.08.08,0,0,0,0,.16c2.17-.25,4.35-.45,6.53-.53,1,0,2.09,0,3.13,0H436a2,2,0,0,0,.89-.08q1.42,1.85,2.84,3.71c.75,1,1.49,2,2.22,3s1.42,2.15,2.24,3.11C444.23,324.58,444.34,324.49,444.3,324.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "431.038px 309.909px"
    },
    id: "elduhdys11rtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,303.72a23.88,23.88,0,0,0-3.78-.18c-1.26,0-2.53,0-3.79.08-.11,0-.1.16,0,.16,1.28-.1,2.56-.12,3.84-.1s2.48.14,3.71.1C425.25,303.78,425.25,303.73,425.21,303.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.4px 303.658px"
    },
    id: "elxnqy3kmna49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.31,306.57c.14-1.21.29-2.42.55-3.61a.08.08,0,1,0-.16,0c-.18,1.19-.41,2.37-.58,3.56-.09.59-.17,1.19-.25,1.78a8.76,8.76,0,0,0-.14,1.69.11.11,0,0,0,.21,0,10.65,10.65,0,0,0,.18-1.69C436.17,307.72,436.24,307.14,436.31,306.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "436.295px 306.474px"
    },
    id: "elzkxvk82cao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,293.19c-.31,1.18-.62,2.37-.83,3.56-.11.61-.21,1.22-.29,1.83a7.67,7.67,0,0,0-.12,1.79.05.05,0,0,0,.1,0,9.71,9.71,0,0,0,.27-1.7c.08-.59.17-1.17.27-1.76.22-1.23.44-2.45.75-3.66C434.16,293.15,434,293.09,434,293.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "433.45px 296.779px"
    },
    id: "elpzrlzugqro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,364.89c-.2-2.22-.42-4.45-.65-6.67q-.71-6.6-1.59-13.19c-.59-4.37-1.15-8.76-1.86-13.12a31.85,31.85,0,0,0-1.35-6,5.65,5.65,0,0,0-3.3-3.73c-4.16-1.43-7,2.88-8.64,5.93-.05.09.08.16.14.08,1-1.45,3.78-5.5,6.94-5.31,2.12.12,3.82,1.63,4.84,6.92,2.54,13.19,4.83,40,5.1,41.71.14.93.79.89.8-.11C388.39,369.26,388.14,367.07,388,364.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.514px 347.039px"
    },
    id: "el5vlte7whecm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,326.52s3.64-12.84-4.4-6.42C353.9,330.79,353.43,354,353.43,354s23.78-13.81,26.73-22.92C384.57,317.54,371.68,326.52,371.68,326.52Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "367.255px 336.151px"
    },
    id: "elykidtcnz0pe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.18,332.82c-1.86.38-3.76.63-5.64.9l-2.68.38c-.6.08-1.21.14-1.82.21,1.77-2.44,3.56-4.87,5.26-7.36a.1.1,0,0,0-.16-.12,54.44,54.44,0,0,0-4,4.59l-1.06-3c-.4-1.15-.84-2.29-1.13-3.48,0-.1-.18,0-.15.05.32,1.17.55,2.38.87,3.56s.65,2.26,1.05,3.37c-.87,1.13-1.71,2.29-2.52,3.46-.41-1.16-.92-2.28-1.27-3.46,0-.1-.19-.05-.16,0,.43,1.31.66,2.66,1.06,4-.55.8-1.09,1.6-1.61,2.4-1,1.49-1.87,3-2.75,4.52a.35.35,0,0,0-.21.36c-1.5,2.6-2.93,5.23-4.34,7.89a.08.08,0,0,0,.14.08c1.41-2.63,3-5.19,4.61-7.7h0a3.09,3.09,0,0,1,.78-.15l.82-.18c.61-.13,1.22-.29,1.83-.44,1.21-.3,2.4-.59,3.63-.8.1,0,.05-.17,0-.15-1.44.27-2.88.44-4.34.6-.69.08-1.37.17-2.05.28h-.1q1.27-1.94,2.6-3.86c.86-1.25,1.75-2.49,2.64-3.73.83-.11,1.64-.33,2.46-.48l2.76-.54c1.84-.37,3.68-.78,5.53-1.08C376.33,333,376.28,332.8,376.18,332.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.597px 338.053px"
    },
    id: "elwbsv09gb9zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89,334.09c-.11-.34-.21-.68-.32-1a20.1,20.1,0,0,1-.55-2.16c0-.1-.17-.05-.15,0,.16.73.33,1.45.49,2.17a13,13,0,0,0,.62,2.13.15.15,0,0,0,.28-.08C362.15,334.81,362,334.45,361.89,334.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.564px 333.089px"
    },
    id: "elrpoj3t2muhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,329.85c-1.08.16-2.17.24-3.27.34s-2.17.24-3.26.41c-.06,0-.06.1,0,.09,1.09-.07,2.18-.16,3.27-.3s2.17-.3,3.27-.38C378.72,330,378.71,329.84,378.61,329.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.363px 330.27px"
    },
    id: "el5gsf99zf4uj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,348.64c-.43-9.45-1-18.89-2-28.3-.47-4.69-1-9.37-1.66-14a98.43,98.43,0,0,0-2.71-13.59,26.16,26.16,0,0,0-4.52-9.58,10.29,10.29,0,0,0-9.14-4c-4.13.51-7.47,3.12-10.35,5.95-3.23,3.18-6.19,6.65-9.18,10-.76.86-1.51,1.73-2.26,2.6-.06.08.05.19.12.11,2.93-3.36,6-6.63,9.15-9.75,2.94-2.89,6-6,10-7.24a10.46,10.46,0,0,1,5.84-.14,9.27,9.27,0,0,1,4,2.53c2.3,2.38,3.58,5.61,4.5,8.74,2.54,8.69,3.45,17.8,4.39,26.77s1.61,18.25,2.07,27.41.82,18.41,1.71,27.59c.11,1.13.25,2.26.4,3.39.09.75,1.27.76,1.21,0C406.31,367.63,405.87,358.14,405.45,348.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.317px 328.411px"
    },
    id: "elh7nlvzhvbcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.57,286.12s5.4-10-1-13.2-27.72,20.62-33.95,55.46c0,0,34.47-15.25,46.18-30.45S384.25,279.39,374.57,286.12Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "365.005px 300.506px"
    },
    id: "el5ymx174bnj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.64,294.24c-3.87,0-7.74-.29-11.61-.27l2.18-2.49a34.93,34.93,0,0,0,3-3.52c.05-.08-.06-.19-.14-.13a26.24,26.24,0,0,0-2.93,2.94c-1,1-1.94,2.06-2.9,3.1-1.48,1.61-2.93,3.23-4.38,4.87,0-.16,0-.32,0-.47,0-.68,0-1.36,0-2,0-1.31,0-2.63,0-3.94,0-2.66,0-5.34.2-8,0-.1-.15-.1-.16,0-.18,2.68-.46,5.34-.59,8-.06,1.32-.09,2.63-.11,3.95,0,.67,0,1.35,0,2,0,.37,0,.76,0,1.14-.22.26-.46.51-.68.76-3.09,3.54-6,7.19-8.9,10.91,0-.2,0-.42-.05-.62,0-.41-.09-.82-.13-1.23-.1-.89-.22-1.77-.36-2.66s-.25-1.66-.39-2.49-.39-1.87-.46-2.81a.08.08,0,1,0-.15,0,27.11,27.11,0,0,1,.32,2.84l.24,2.56c.07.85.15,1.7.24,2.56l.12,1.23c0,.2.05.41.08.61a1,1,0,0,0,.16.49l-1.47,1.92c-2,2.59-3.88,5.21-5.8,7.82-.06.08.06.19.12.11,1.82-2.37,3.69-4.7,5.58-7,1.42.06,2.87-.05,4.29-.07s3,0,4.48,0a.08.08,0,0,0,0-.16c-1.5,0-3,.05-4.49.06s-2.75-.06-4.11,0c1.66-2,3.35-4,5-6.05L357.8,306a9.08,9.08,0,0,0,1.73.06h2c1.27,0,2.54,0,3.82-.05,2.63,0,5.26-.13,7.89-.14a.08.08,0,1,0,0-.15c-2.64,0-5.27-.15-7.9-.22-1.28,0-2.55-.07-3.83-.09l-2,0c-.38,0-.78,0-1.18,0l4.35-5.15a.24.24,0,0,0,.08-.09c1.41-1.67,2.82-3.33,4.25-5,.2-.22.4-.44.59-.67,4,.12,8-.14,12-.06C379.75,294.4,379.75,294.24,379.64,294.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.336px 302.851px"
    },
    id: "elzofmmnvwamc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.66,301.09h-.94a.07.07,0,1,0,0,.14h.93A.08.08,0,0,0,377.66,301.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.173px 301.16px"
    },
    id: "el9ryckq3wktc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,301.1c-1.24,0-2.48,0-3.72-.08L370,301a7.14,7.14,0,0,0-1.73,0,.06.06,0,0,0,0,.12,6.74,6.74,0,0,0,1.74.12l1.86,0h3.72C375.68,301.26,375.68,301.1,375.57,301.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.933px 301.1px"
    },
    id: "elt2ds7xc1akl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.74,312.74a50.1,50.1,0,0,0-7.63-.69,0,0,0,0,0,0,.05c2.54.24,5.07.38,7.59.79C364.8,312.91,364.84,312.75,364.74,312.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.954px 312.471px"
    },
    id: "elfw4v3nozbwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,301.64c0-.22-.05-.44-.08-.66-.06-.5-.14-1-.22-1.49-.15-.95-.31-1.89-.49-2.84,0-.08-.17-.06-.16,0,.12,1,.23,1.95.32,2.93l.12,1.44a4.11,4.11,0,0,0,.19,1.36.19.19,0,0,0,.34-.05A1.94,1.94,0,0,0,354.37,301.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.916px 299.531px"
    },
    id: "elebsc4064msg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.11,273.29c-1.24-2.3-2.81-5.33-5.89-5.14-2.54.16-3.69,2.75-4.23,4.9-1.68,6.63-1.8,13.63-2.12,20.43-.7,14.37-1.32,28.75-1.41,43.14q0,6,0,12c0,4.07,0,8.16.28,12.22a.3.3,0,0,0,.6,0c0-3.48-.1-7-.11-10.44s0-6.79.06-10.19q.17-10.31.55-20.62c.26-6.83.56-13.66.85-20.49.14-3.41.29-6.83.44-10.24s.29-6.61.67-9.9c.21-1.85.48-3.69.87-5.5a7.61,7.61,0,0,1,1.59-3.69,3.46,3.46,0,0,1,4.49-.32,9.48,9.48,0,0,1,3.19,4A.08.08,0,0,0,405.11,273.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.301px 314.641px"
    },
    id: "el1xzxxs3iqjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.27,272.19s-2.53-8.94,3.07-4.47c9.32,7.44,9.65,23.63,9.65,23.63s-16.57-9.62-18.63-16C395.29,265.93,404.27,272.19,404.27,272.19Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "407.355px 278.909px"
    },
    id: "elgttjkineih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,284.72c-.15-.25-.31-.49-.47-.74a4.82,4.82,0,0,0,0-.76c0-.38,0-.77,0-1.15,0-.76,0-1.52.08-2.27a.08.08,0,0,0-.16,0c0,.74-.07,1.49-.09,2.23,0,.37,0,.74,0,1.11,0,.14,0,.31,0,.48-.65-1-1.32-2-2-3-.2-.29-.41-.57-.61-.85a15.83,15.83,0,0,1-.05-2.92c0-1,0-2.08.06-3.12,0-.1-.16-.1-.16,0,0,1.08-.08,2.16-.14,3.24a19.74,19.74,0,0,0-.06,2.31c-1.6-2.17-3.3-4.27-5-6.36-.06-.07-.18,0-.12.1,1.06,1.35,2.08,2.73,3.08,4.13-1.95-.46-3.93-.72-5.91-1-.1,0-.14.14,0,.16,2.1.32,4.16.84,6.23,1.3h0c.79,1.12,1.58,2.24,2.35,3.37l.94,1.38h-.08l-.65-.09-1.38-.12c-.95-.08-1.91-.13-2.87-.18-.1,0-.09.16,0,.16.94,0,1.88.09,2.81.19l1.49.18.64.08.19,0c.53.78,1.07,1.56,1.59,2.34.94,1.39,1.78,2.87,2.77,4.2a.08.08,0,0,0,.13-.08A41.92,41.92,0,0,0,413.5,284.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.986px 281.016px"
    },
    id: "elx9537nom99e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,274.62c0-.35,0-.7,0-1.05a16,16,0,0,1,.09-2.19.08.08,0,1,0-.15,0c0,.73-.08,1.45-.12,2.17,0,.37,0,.73,0,1.09v.5a1.8,1.8,0,0,0,0,.52.07.07,0,0,0,.14,0,1.54,1.54,0,0,0,0-.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.328px 273.501px"
    },
    id: "elrwxumezd5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.33,278.32c-.62-.11-1.25-.14-1.87-.19s-1.36-.12-2-.21a.08.08,0,1,0,0,.16c1.31.08,2.61.32,3.92.36C407.39,278.45,407.4,278.33,407.33,278.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.384px 278.18px"
    },
    id: "elite6pb44o5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.53,278.37c.05.07,0,.27,0,.35v.91c0,.21,0,.42,0,.63a1.4,1.4,0,0,0,0,.54s.05,0,.06,0a.57.57,0,0,0,0-.26,2.71,2.71,0,0,1,0-.29v-.62c0-.21,0-.42,0-.63v-.28c0-.09,0-.28,0-.35S412.43,278.22,412.53,278.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "412.551px 279.542px"
    },
    id: "elka5h1rqha2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.49,321c-3.48-2.61-6.61-6.37-11.3-6.56-3.87-.15-6.58,2.76-8.13,6a34.67,34.67,0,0,0-1.89,5.35q-1.05,3.66-2,7.37-1.81,7.29-3.1,14.7c-.47,2.75-.91,5.51-1.26,8.28a70.93,70.93,0,0,0-.81,8.48.44.44,0,0,0,.87.1c.47-2.32.67-4.71,1-7.05s.7-4.71,1.09-7.05q1.2-7,2.78-14c1-4.39,2-8.84,3.39-13.11,1-3.06,2.64-6.63,5.95-7.73,5-1.67,9.59,2.58,13.27,5.35C405.46,321.18,405.57,321.06,405.49,321Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.259px 339.751px"
    },
    id: "elxqptzdbudb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,318.5s-3.22-9.17,1.43-11c7-2.69,25.18,17.83,21.61,49.27,0,0-14.07-7.75-24.47-16.48s-13-20.12-8.47-23.06S401.89,318.5,401.89,318.5Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "407.621px 332.017px"
    },
    id: "elbo0bkobmo2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.83,350.06a24.09,24.09,0,0,0-1.69-3.17c-.6-1.08-1.2-2.15-1.82-3.21-1.21-2.07-2.41-4.14-3.65-6.2l-.61-1c0-.12.05-.25.07-.37l.21-.91c.16-.68.28-1.37.4-2.06.26-1.34.49-2.7.85-4,0-.09-.13-.12-.15,0-.29,1.34-.72,2.67-1.11,4-.2.65-.41,1.29-.58,1.95l-.18.67c-1.49-2.45-3-4.89-4.66-7.25a3.34,3.34,0,0,0,.17-1c.05-.46.1-.92.16-1.38.12-1,.24-2.07.39-3.1.3-2,.6-4,1.1-6,0-.1-.13-.13-.15,0-.51,2-1.05,4-1.43,6-.18,1-.36,2-.49,3-.06.5-.12,1-.17,1.5,0,.14,0,.3-.06.45-.5-.71-1-1.43-1.53-2.12-1.61-2.12-3.28-4.18-5-6.24-.06-.08-.2,0-.13.09a111.4,111.4,0,0,1,7.92,11.56l1.37,2.23-.46-.06c-.59-.08-1.18-.11-1.77-.17l-3.56-.31c-2.37-.19-4.75-.33-7.11-.58-.1,0-.13.14,0,.15,2.4.28,4.78.66,7.17,1,1.18.17,2.35.33,3.53.48a14.07,14.07,0,0,0,2.71.27c.93,1.52,1.87,3,2.8,4.54-.21,0-.43,0-.63,0h-3.39c-1.53,0-3.06,0-4.58,0-.11,0-.09.15,0,.15,1.55,0,3.09.1,4.64.18l2.2.13,1.1.08a2.21,2.21,0,0,0,1,0l2.38,3.86c.73,1.19,1.47,2.37,2.22,3.55a29,29,0,0,0,2.39,3.58C422.74,350.21,422.87,350.16,422.83,350.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.956px 333.647px"
    },
    id: "elk1j6q47akr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.12,324.65a22.08,22.08,0,0,1-.63,3c-.26,1-.55,2-.88,3a.1.1,0,1,0,.19.06c.31-1,.59-2,.83-3s.4-2,.65-3.05A.08.08,0,0,0,416.12,324.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "415.441px 327.681px"
    },
    id: "elund7fdbl79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,330.79a1.24,1.24,0,0,0-.77-.29l-1.33-.18c-.82-.11-1.65-.2-2.47-.3-1.72-.2-3.43-.37-5.15-.58-.1,0-.13.14,0,.15,1.62.2,3.23.45,4.85.66l2.37.31,1.15.12a4,4,0,0,1,1.3.23A.07.07,0,0,0,405.78,330.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "400.887px 330.175px"
    },
    id: "el87wgta2vt1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,344.62c-.81-.07-1.63-.1-2.44-.12l-1.23,0-.59,0a4,4,0,0,1-.77,0c-.11,0-.12.17,0,.15a3.47,3.47,0,0,1,.72,0l.64,0,1.22.08c.81.05,1.63.1,2.44.1C416.19,344.79,416.2,344.62,416.1,344.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.577px 344.665px"
    },
    id: "el4vhlv9bu3ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.06,341.1l.27-1.38c.16-.91.33-1.82.5-2.72a.08.08,0,0,0-.16,0l-.6,2.65c-.1.44-.2.88-.29,1.32,0,.21-.08.41-.13.62a1.78,1.78,0,0,0-.07.65.1.1,0,0,0,.18.05A3.26,3.26,0,0,0,421.06,341.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.202px 339.625px"
    },
    id: "el019fgpf0zfqph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.4 361.1 374.38 372.25 377.71 409.88 407.18 409.88 411.34 372.25 412.57 361.1 373.4 361.1",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "392.985px 385.49px"
    },
    id: "elq5sxdoqh2fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.4 361.1 374.38 372.25 411.34 372.25 412.57 361.1 373.4 361.1",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.985px 366.675px"
    },
    id: "el39azeiumtnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliqabnlfr3eh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.48,
    y: 358.06,
    width: 45.01,
    height: 9.04,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "392.985px 362.58px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elbff6jgeda27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-mark--inject-2",
    className: "animable",
    style: {
      transformOrigin: "269.416px 262.125px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,324.13q0-24,7.84-43.13t32.34-33.33q7.36-4.41,18.14-10a146.32,146.32,0,0,0,21.07-13.48,77,77,0,0,0,17.4-18.37,42.36,42.36,0,0,0,7.11-24.27A40.08,40.08,0,0,0,314,163.37a41.61,41.61,0,0,0-10.29-13.23,42.86,42.86,0,0,0-15-8.09,58,58,0,0,0-17.4-2.69A50.56,50.56,0,0,0,251.77,143a66.89,66.89,0,0,0-15.92,9.31,78.06,78.06,0,0,0-12.75,12.75,139.83,139.83,0,0,0-9.55,13.47h-7.38l-35.27-29.4a95.17,95.17,0,0,1,16.91-27,103.76,103.76,0,0,1,24-19.85A112.47,112.47,0,0,1,241,90.1a125.77,125.77,0,0,1,32.35-4.17,128.54,128.54,0,0,1,36.76,5.39,93.42,93.42,0,0,1,32.59,17.16,89,89,0,0,1,23.53,30.14q9.06,18.38,9.06,43.87a94.76,94.76,0,0,1-3.67,27.69A77.22,77.22,0,0,1,361.07,232a91.89,91.89,0,0,1-16.17,17.64,185.28,185.28,0,0,1-21.08,15.19q-9.81,5.9-19.6,11.28a118,118,0,0,0-17.89,12,58.52,58.52,0,0,0-13.24,15.2q-5.14,8.58-5.14,20.83Zm1,114.19V370.69h54.4v67.63Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "273.101px 262.125px"
    },
    id: "elvyzu4q3dtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloej34qu51a9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "273.101px 262.125px"
    },
    className: "animable",
    id: "elexfoasydnum"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,324.13q0-24,7.84-43.13t32.34-33.33q7.36-4.41,18.14-10a146.32,146.32,0,0,0,21.07-13.48,77,77,0,0,0,17.4-18.37,42.36,42.36,0,0,0,7.11-24.27A40.08,40.08,0,0,0,314,163.37a41.61,41.61,0,0,0-10.29-13.23,42.86,42.86,0,0,0-15-8.09,58,58,0,0,0-17.4-2.69A50.56,50.56,0,0,0,251.77,143a66.89,66.89,0,0,0-15.92,9.31,78.06,78.06,0,0,0-12.75,12.75,139.83,139.83,0,0,0-9.55,13.47h-7.38l-35.27-29.4a95.17,95.17,0,0,1,16.91-27,103.76,103.76,0,0,1,24-19.85A112.47,112.47,0,0,1,241,90.1a125.77,125.77,0,0,1,32.35-4.17,128.54,128.54,0,0,1,36.76,5.39,93.42,93.42,0,0,1,32.59,17.16,89,89,0,0,1,23.53,30.14q9.06,18.38,9.06,43.87a94.76,94.76,0,0,1-3.67,27.69A77.22,77.22,0,0,1,361.07,232a91.89,91.89,0,0,1-16.17,17.64,185.28,185.28,0,0,1-21.08,15.19q-9.81,5.9-19.6,11.28a118,118,0,0,0-17.89,12,58.52,58.52,0,0,0-13.24,15.2q-5.14,8.58-5.14,20.83Zm1,114.19V370.69h54.4v67.63Z",
    id: "el417miw00pld",
    className: "animable",
    style: {
      transformOrigin: "273.101px 262.125px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.66,324.13q0-24,7.84-43.13t32.35-33.33q7.35-4.41,18.13-10a145.86,145.86,0,0,0,21.08-13.48,77.18,77.18,0,0,0,17.4-18.37,42.43,42.43,0,0,0,7.1-24.27,40.08,40.08,0,0,0-3.92-18.13,41.61,41.61,0,0,0-10.29-13.23,42.86,42.86,0,0,0-15-8.09,58,58,0,0,0-17.4-2.69A50.48,50.48,0,0,0,244.4,143a67,67,0,0,0-15.93,9.31,78,78,0,0,0-12.74,12.75,140,140,0,0,0-9.56,13.47l-42.64-29.4a95,95,0,0,1,16.91-27,103.5,103.5,0,0,1,24-19.85A112.53,112.53,0,0,1,233.62,90.1,125.69,125.69,0,0,1,266,85.93a128.49,128.49,0,0,1,36.76,5.39,93.33,93.33,0,0,1,32.59,17.16,88.9,88.9,0,0,1,23.53,30.14q9.06,18.38,9.07,43.87a94.75,94.75,0,0,1-3.68,27.69A77,77,0,0,1,353.69,232a91.89,91.89,0,0,1-16.17,17.64,183.51,183.51,0,0,1-21.08,15.19q-9.79,5.9-19.6,11.28a118,118,0,0,0-17.89,12,58.48,58.48,0,0,0-13.23,15.2q-5.14,8.58-5.15,20.83Zm1,114.19V370.69H262v67.63Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "265.746px 262.125px"
    },
    id: "el7bawkxgd39d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "123.993px 274.553px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.24,443.73c-2.13.68-62.86-.1-65.15-1.6-.88-.56-1.28-9.41-1.46-20.13v-.33c0-2.21-.07-4.49-.08-6.79,0-.32,0-.64,0-.95-.08-15.46.16-31.51.16-31.51l40.63.41L157.11,414l-.05,1.24-.25,6.46,0,.66S179.9,433.1,182.25,435,186.37,443.05,184.24,443.73Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "151.365px 413.199px"
    },
    id: "elow0x2c5uoin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.24,443.73c-2.13.68-62.86-.1-65.15-1.6-.88-.56-1.28-9.41-1.46-20.13v-.33c0-2.21-.07-4.49-.08-6.79,0-.32,0-.64,0-.95l39.57.11-.05,1.24-.25,6.46,0,.66S179.9,433.1,182.25,435,186.37,443.05,184.24,443.73Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "151.373px 428.954px"
    },
    id: "eli690c9iu6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.24,443.73c-1.31.42-24.84.28-43.26-.24-11.5-.31-21-.79-21.89-1.36s-1.27-9.16-1.45-19.68c0-.15,0-.3,0-.45s0-.23,0-.34l39.19.08,0,.66s23.12,10.7,25.46,12.61S186.37,443.05,184.24,443.73Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "151.422px 432.818px"
    },
    id: "eltbyii15p1ln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,441.36c-10.24-.38-51.55-1-61.7-.57-.08,0-.08.06,0,.07,10.14.6,51.45.85,61.69.67C183.8,441.53,183.8,441.37,183.59,441.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.788px 441.116px"
    },
    id: "el27lyn3qps9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,421.9c-4-.8-8.95-.25-12.07,2.58-.12.11,0,.28.17.24a57.13,57.13,0,0,1,11.88-2.31A.26.26,0,0,0,161.17,421.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.211px 423.146px"
    },
    id: "elhyfj8do0hu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,423.69c-4-.8-8.95-.25-12.07,2.58-.12.11,0,.28.17.24A57,57,0,0,1,164,424.2.26.26,0,0,0,164.06,423.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "158.095px 424.936px"
    },
    id: "eln3rse20wsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.94,425.48c-4-.8-8.95-.25-12.07,2.58-.12.11,0,.28.17.24A57.13,57.13,0,0,1,166.92,426,.26.26,0,0,0,166.94,425.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.006px 426.726px"
    },
    id: "el8bsv7d0f1sw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.53,413.18c-1.56-2.2-4.52-1.25-6.22.14a21.45,21.45,0,0,0-6.32,9.15.1.1,0,0,0,.09.14c0,.31.28.64.63.51,3.34-1.19,7.06-2,9.94-4.22C166.33,417.63,168,415.27,166.53,413.18Zm-7.13,7.1c-1.63.63-3.28,1.17-4.88,1.85,1.24-1.78,2.39-3.6,3.81-5.26a25.87,25.87,0,0,1,2.16-2.28c1.22-1.07,6-3.33,5.22,1.08C165.29,418.1,161.35,419.54,159.4,420.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.539px 417.511px"
    },
    id: "el0e72vhuoe2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,421.28c3.3,1.46,7.12,1.44,10.65,1.83.36,0,.55-.35.49-.65a.11.11,0,0,0,.06-.16,21.62,21.62,0,0,0-8.26-7.45c-2-1-5.08-1.2-6.08,1.3S141.83,420.43,143.76,421.28Zm-1.78-2.9c-1.76-4.11,3.41-3,4.83-2.24a21.6,21.6,0,0,1,2.63,1.72,62.07,62.07,0,0,1,4.92,4.24c-1.72-.3-3.45-.44-5.18-.68C147.12,421.15,143,420.65,142,418.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.673px 418.632px"
    },
    id: "elgk7n5rcnay4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,443.49c-11.5-.31-21-.79-21.89-1.36s-1.27-9.16-1.45-19.68C122.36,426.66,134.08,437.11,141,443.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.33px 432.97px"
    },
    id: "elda3tak9upx4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.24,207.48s9.12,102.62,10.6,110.45c.35,1.79.56,11.49.7,23.95.31,27.21.13,76.27.13,76.27h42.81s-1.27-85-3.17-100.65-14-110-14-110Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "132.36px 312.815px"
    },
    id: "el65umaa1ueun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,410.69c-6.68-.14-4.76-.19-11.44-.26-3.27,0-24.75-.21-27.81.29a.07.07,0,0,0,0,.14c3.06.5,24.54.32,27.81.28,6.68-.06,4.76-.11,11.44-.25A.1.1,0,0,0,157.54,410.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.93px 410.795px"
    },
    id: "elz0wl0dvr1el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,362.1q-.08-9.32-.14-18.63c0-6,0-12-.32-18-.58-12.17-3-24.13-4.8-36.16s-3.22-24.11-4.55-36.2c-1.49-13.56-2.8-27.15-4.19-40.72,0-.09-.16-.09-.15,0,2,24.24,4.27,48.47,7.62,72.56q1.26,9,2.74,17.94c1,6,2,12.08,2.47,18.19s.54,12,.6,18q.11,9.32.19,18.62c.13,13.78.26,35,.4,48.78a.21.21,0,0,0,.41,0C125,394.12,124.89,374.39,124.8,362.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.865px 309.484px"
    },
    id: "elay9af7k93of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.21,207.48s18.15,102.62,19.63,110.45c.35,1.79.56,11.49.7,23.95v0L137,207.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.605px 274.68px"
    },
    id: "elmubcf33nr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,447.35c-2.17.53-62.7-4.56-64.88-6.21-.84-.62-.61-9.48,0-20.18,0-.11,0-.23,0-.34.12-2.2.25-4.47.41-6.77l.06-1c1-15.43,2.39-31.42,2.39-31.42L113,384.77l-3.43,31-.13,1.23-.7,6.43-.07.66s22.29,12.31,24.5,14.38S136.7,446.82,134.53,447.35Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "102.37px 414.409px"
    },
    id: "elikj9i0yc0mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,447.35c-2.17.53-62.7-4.56-64.88-6.21-.84-.62-.61-9.48,0-20.18,0-.11,0-.23,0-.34.12-2.2.25-4.47.41-6.77l.06-1,39.45,2.91-.13,1.23-.7,6.43-.07.66s22.29,12.31,24.5,14.38S136.7,446.82,134.53,447.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "102.37px 430.119px"
    },
    id: "el7tpn789ebqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,447.35c-2.17.53-62.7-4.56-64.88-6.21-.84-.62-.61-9.48,0-20.18,0-.11,0-.23,0-.34l39.09,2.85-.07.66s22.29,12.31,24.5,14.38S136.7,446.82,134.53,447.35Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "102.37px 434.004px"
    },
    id: "elvl6cwp2ze19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,444.94c-10.18-1.11-51.35-4.61-61.5-4.94-.08,0-.09.06,0,.07,10.06,1.32,51.26,4.49,61.49,5C134.24,445.12,134.26,445,134,444.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.311px 442.541px"
    },
    id: "elmka510xe22h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06,423.94c-4-1.08-8.91-.88-12.22,1.72-.13.1,0,.29.15.26a56.46,56.46,0,0,1,12-1.47A.26.26,0,0,0,113.06,423.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.018px 424.623px"
    },
    id: "el9tyverjz8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,425.93c-4-1.08-8.92-.88-12.23,1.72-.12.1,0,.29.15.26a56.54,56.54,0,0,1,12-1.47A.26.26,0,0,0,115.82,425.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.775px 426.613px"
    },
    id: "elewxt665seat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.57,427.92c-4-1.08-8.92-.88-12.23,1.72-.12.1,0,.29.16.26a56.37,56.37,0,0,1,12-1.47A.26.26,0,0,0,118.57,427.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "112.525px 428.603px"
    },
    id: "el989mkjuh585",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,415.63c-1.39-2.31-4.41-1.58-6.21-.31a21.43,21.43,0,0,0-7,8.68c0,.08,0,.13.08.15a.5.5,0,0,0,.59.55c3.41-.95,7.19-1.54,10.21-3.51C118.51,420,120.34,417.81,119,415.63Zm-7.61,6.57c-1.67.51-3.35.93-5,1.5a63.75,63.75,0,0,1,4.17-5,23.23,23.23,0,0,1,2.32-2.12c1.29-1,6.21-2.91,5.13,1.44C117.44,420.44,113.4,421.6,111.41,422.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "112.625px 419.418px"
    },
    id: "el0158wpuu62t3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.74,422.09c3.19,1.69,7,1.94,10.49,2.57.36.07.58-.3.54-.6a.11.11,0,0,0,.06-.16,21.4,21.4,0,0,0-7.71-8c-1.9-1.11-5-1.56-6.15.86S93.88,421.1,95.74,422.09Zm-1.57-3c-1.47-4.23,3.61-2.76,5-1.9a23.25,23.25,0,0,1,2.5,1.91,62.25,62.25,0,0,1,4.61,4.58c-1.7-.42-3.41-.69-5.12-1C99.1,422.19,95,421.41,94.17,419.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.7415px 419.835px"
    },
    id: "ell96x2jwel7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47,420.46,67.7,418.65S79.38,324.79,79.59,319c.56-15,10.51-111.59,10.51-111.59h52.24s-3.3,22.31-8.93,36.45a65.16,65.16,0,0,0-10.93,5s-4.9,63.89-5.08,71.86C117,336.5,110.47,420.46,110.47,420.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "105.02px 313.935px"
    },
    id: "ely6ps91bkhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.33,412.62c-6.66-.42-4.74-.39-11.42-.74-3.26-.17-24.72-1.26-27.79-.89-.07,0-.07.12,0,.14,3,.63,24.51,1.36,27.77,1.46,6.68.22,4.77.09,11.45.23A.1.1,0,0,0,109.33,412.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.7513px 411.867px"
    },
    id: "elb0zlq173nbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,213.17c-1.94,24.33-3.93,48.67-6.16,73s-4.84,48.76-8,73.05C78,372.77,76,391.88,73.89,405.4c0,.09.12.13.14,0,4.31-24,7.48-53.84,10.17-78.09s4.9-48.57,6.87-72.89c1.11-13.76,2.11-27.53,3.17-41.29C94.25,213,94,213,93.93,213.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.0651px 309.26px"
    },
    id: "elvrju8ejoi2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,242.92a80.76,80.76,0,0,0-12.79,6,.14.14,0,0,0,.12.26c4.31-1.85,8.7-3.62,12.9-5.71A.28.28,0,0,0,135.27,242.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.04px 246.045px"
    },
    id: "elgzmqt2wuva6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,213.35c0-.15-.27-.18-.27,0,0,5.11-.29,9.61-.72,14.4-.2,2.22-2,14.48-5.84,13.59-.64-.15-1-.79-1.07-1.76a14.74,14.74,0,0,1,.51-3.76c.42-2.57.77-5.14,1-7.74a70.37,70.37,0,0,0-.16-14.51.13.13,0,0,0-.25,0,132.87,132.87,0,0,1-1.17,20c-.48,3.19-2.09,8,1.25,8.48s5.6-7.54,6-9.74A73.22,73.22,0,0,0,136.64,213.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.404px 227.648px"
    },
    id: "elmvgsqbi28p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91,241.65a19,19,0,0,0-.86,2.54,5.58,5.58,0,0,0-.36,2.09c0,.14.19.15.26.06a7.4,7.4,0,0,0,.9-2c.29-.79.6-1.57.87-2.37A.43.43,0,0,0,129.91,241.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.719px 243.887px"
    },
    id: "el31m0l1t82gv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,217.36a6.51,6.51,0,0,0-.16-1.59.09.09,0,0,0-.16,0,7,7,0,0,0-.18,1.38c0,.53-.12,1-.18,1.58a23.17,23.17,0,0,1-.56,3.21,11.39,11.39,0,0,1-2.94,5.28,15.18,15.18,0,0,1-5,3.27A56.61,56.61,0,0,1,97,232.32a.08.08,0,0,0,0,.16,18.37,18.37,0,0,0,6.9-1.36,14.85,14.85,0,0,0,5.19-3.31,11.53,11.53,0,0,0,3-5.43,16.61,16.61,0,0,0,.42-3.22A15.45,15.45,0,0,0,112.49,217.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "104.724px 224.101px"
    },
    id: "elq5n71dthwy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.62,119.58c3.22,3.89,6.72,14.4,6.59,17.27s-17.82,9.39-20.32,7.83-12.34-15.46-12.43-20.61S160.28,115.56,163.62,119.58Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "153.837px 131.36px"
    },
    id: "elhgfkiz5ct5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,112.44c-1.62-1.69-6.86-6.74-9.19-4.46-1.46,1.42,2.06,5.31,3.54,6.85,3.05,3.16,5.41,8.75,6.51,11.48s6.25-2.66,6.25-2.66S141.23,116.83,137,112.44Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "135.786px 117.24px"
    },
    id: "elqsx8h9e6luk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,129.36s1.81,4.86,4.76,4.75,2.2-4.29,2.16-4.59c.09.26,1.87,4.68,4.83,4.27s1.7-4.52,1.61-4.78c.16.21,2.44,3,4.61,2.17,3.74-1.42-1.87-8.69-1.33-11.88,0,0,5.52.31,5.68.28,0,0-5.2-7-9.55-7.52a2.78,2.78,0,0,0-3,1.82s-1.43-2.45-3.77-2.2c-1.2.13-2.06,2.17-2.06,2.17a3.48,3.48,0,0,0-3.29-1.56c-1.65.27-2.47,2.33-2.56,3.13C138.69,121.54,141.3,129.36,141.3,129.36Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "151.445px 122.887px"
    },
    id: "ely29ep5sr6tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.58,114.86s-.07,0-.08,0a24.9,24.9,0,0,0,1.81,14.7c.07.14.33.09.28-.08A51.22,51.22,0,0,1,139.58,114.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "140.348px 122.251px"
    },
    id: "ellruoqvzfq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23,113.78c0-.06-.09-.06-.1,0a23.29,23.29,0,0,0,3,15.9c.11.17.37.21.26,0C146.56,126.36,145.13,118.41,145.23,113.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.609px 121.779px"
    },
    id: "elmxeh2mikda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,129.27c-2.74-4.7-3.71-9.8-3.94-15.19,0-.07-.1-.06-.12,0-.6,2.67-.09,6.08.53,8.71a14.35,14.35,0,0,0,3.37,6.57C154.89,129.44,155,129.37,155,129.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.836px 121.713px"
    },
    id: "elllblcx76yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,129.36a16.55,16.55,0,0,0,1.54,2.56A5.5,5.5,0,0,0,145,133.8a1.8,1.8,0,0,0,1.29,0,2.64,2.64,0,0,0,1.1-.75,3.23,3.23,0,0,0,.54-2.55l-.37-2.16,1.1,1.9a9.09,9.09,0,0,0,1.82,2.27,3.17,3.17,0,0,0,2.44.94,1.83,1.83,0,0,0,1.7-1.56,5.63,5.63,0,0,0-.35-2.76l-.89-2.44,1.63,2a8.76,8.76,0,0,0,1.55,1.49,3.49,3.49,0,0,0,1.86.74,1.66,1.66,0,0,0,1.52-.84,3.65,3.65,0,0,0,.15-2,28.93,28.93,0,0,0-1.2-4.34c-.24-.72-.48-1.45-.68-2.19a5.43,5.43,0,0,1-.26-2.26,6,6,0,0,0,.46,2.2c.26.71.55,1.41.84,2.12A24.54,24.54,0,0,1,160.7,128a4.29,4.29,0,0,1-.1,2.45,2.34,2.34,0,0,1-2.2,1.34,4.24,4.24,0,0,1-2.33-.86,9.33,9.33,0,0,1-1.75-1.63l.74-.44a6.37,6.37,0,0,1,.45,3.25,2.65,2.65,0,0,1-.86,1.59,3,3,0,0,1-1.63.68,4,4,0,0,1-3.1-1.19,9.56,9.56,0,0,1-2-2.52l.73-.26a3.84,3.84,0,0,1-.84,3.11,3.25,3.25,0,0,1-1.4.86,2.26,2.26,0,0,1-1.64-.12,5.57,5.57,0,0,1-2.19-2.17A13.32,13.32,0,0,1,141.3,129.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.066px 126.885px"
    },
    id: "elq1ygjhynizp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,142.61s-19.07-9.75-11.6-15.33c2.21-1.66,13.3-5.83,14.18-3.62,1.14,2.85-3.17,5.46-6.13,6.66,0,0,6.95,2.41,6.72,7.74A5.31,5.31,0,0,1,147.8,142.61Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "142.72px 132.819px"
    },
    id: "el6cfvxh7agij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,127.78a10.85,10.85,0,0,1,2.66-1.88,25.75,25.75,0,0,1,3-1.36,37.72,37.72,0,0,1,6.3-1.86,5.86,5.86,0,0,1,1.74-.1,2.29,2.29,0,0,1,1,.3,1.62,1.62,0,0,1,.42.35,1.5,1.5,0,0,1,.27.47,2.73,2.73,0,0,1,0,1.91,4.92,4.92,0,0,1-.92,1.53,9.75,9.75,0,0,1-2.65,2.11,21.37,21.37,0,0,1-3,1.42l0-.71a13.53,13.53,0,0,1,2.25,1.13,12.05,12.05,0,0,1,2,1.51,8.46,8.46,0,0,1,1.52,2,6.5,6.5,0,0,1,.79,2.33,7.41,7.41,0,0,0-1-2.19,8.93,8.93,0,0,0-1.62-1.74,11.4,11.4,0,0,0-2-1.34,12.49,12.49,0,0,0-2.17-.94l-.93-.29.9-.42a23.61,23.61,0,0,0,2.83-1.46,9.77,9.77,0,0,0,2.4-1.95,2.7,2.7,0,0,0,.76-2.52c-.22-.7-1.41-.67-2.42-.52s-2.08.42-3.13.68-2.08.55-3.11.88A20.91,20.91,0,0,0,135.61,127.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.391px 129.743px"
    },
    id: "elw4xrtfh5sjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.85,156.41c16.86,20.81,41.37,34.29,47.42,29.9s-14.34-27.37-14.69-27.71c-1.19-1.14-10.21-5.83-26.59-12.73C115.92,139.1,118.32,147.12,125.85,156.41Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "147.202px 165.245px"
    },
    id: "el5400y0i7q4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,154,138.3,170.7s-10.66-11-16.3-18.28-5.08-12.94,7.54-8.24A158.34,158.34,0,0,1,151,154Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "134.789px 156.58px"
    },
    id: "eli7woerboea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,166.87c1.55-2.28,3.17-4.52,4.83-6.71.83-1.08,1.63-2.18,2.48-3.25s1.82-2.14,2.69-3.24c.06-.08.18,0,.12.08-.8,1.1-1.52,2.25-2.32,3.35s-1.68,2.24-2.53,3.36q-2.51,3.3-5.17,6.48C137.14,167,137,166.94,137.09,166.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.143px 160.301px"
    },
    id: "el8aipog93nhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.38,162.68l-6.08,8s-10.66-11-16.3-18.28l-.54-.71-.23-.33-.35-.51q-.45-.66-.81-1.29c-.09-.15-.17-.3-.25-.45a12.22,12.22,0,0,1-1-2.39,6.1,6.1,0,0,1-.17-.78c0-.13,0-.25,0-.37C124.19,149.41,137.19,157.82,144.38,162.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.515px 158.125px"
    },
    id: "elmc98mtxsew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89,217.73s-57.87,1-58.21.64c-.9-1,10.79-60.59,22.88-72.87,4.27-4.34,13.08-2.57,14.55-1.86,3.39,1.64,6.58,5.18,9.25,11.74C138.7,168.5,145.62,216.79,144.89,217.73Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "115.787px 180.562px"
    },
    id: "eln49yk980mq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0bl3dogq9w4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127,145.6H109.47l.09-.1a7.77,7.77,0,0,1,1.35-1.09h14.55A12,12,0,0,1,127,145.6Zm1.93,2H107.82c-.28.37-.55.77-.82,1.19h22.85C129.56,148.37,129.26,148,129,147.6Zm2.18,3.19H105.79c-.22.39-.44.79-.65,1.2h26.65C131.58,151.58,131.36,151.17,131.13,150.79Zm1.63,3.2H104.13l-.57,1.19h29.71C133.11,154.77,132.94,154.37,132.76,154Zm1.27,3.19H102.68l-.51,1.19h32.25C134.29,158,134.16,157.56,134,157.18Zm1,3.19H101.36c-.15.4-.31.79-.47,1.2h34.47Zm.86,3.19H100.15c-.14.4-.29.79-.43,1.2h36.47Q136,164.15,135.89,163.56Zm.78,3.2H99c-.14.39-.27.79-.4,1.19h38.32Zm.72,3.19H98c-.13.39-.25.79-.38,1.19h40.08C137.56,170.74,137.48,170.34,137.39,170Zm.68,3.19H97c-.13.39-.25.79-.37,1.2h41.74C138.24,173.94,138.16,173.54,138.07,173.14Zm.65,3.19H96c-.12.4-.24.8-.35,1.2H139Zm.62,3.2H95.06c-.12.4-.23.79-.34,1.19h44.84C139.49,180.32,139.42,179.92,139.34,179.53Zm.59,3.19H94.17c-.11.4-.22.8-.32,1.19h46.3C140.08,183.51,140,183.12,139.93,182.72Zm.57,3.19H93.32c-.11.4-.21.8-.31,1.2h47.7Q140.62,186.51,140.5,185.91Zm.57,3.2H92.49c-.09.4-.19.79-.29,1.19h49.06C141.2,189.91,141.13,189.51,141.07,189.11Zm.52,3.19H91.7c-.09.4-.19.8-.28,1.19h50.37C141.73,193.1,141.66,192.7,141.59,192.3Zm.52,3.19H90.94c-.09.41-.18.81-.28,1.2H142.3C142.24,196.29,142.18,195.9,142.11,195.49Zm.51,3.19H90.21c-.09.4-.18.81-.27,1.2h52.85C142.73,199.49,142.67,199.09,142.62,198.68Zm.47,3.2H89.5c-.08.4-.17.8-.25,1.19h54Zm.46,3.19H88.82c-.08.41-.16.8-.24,1.19h55.14C143.66,205.87,143.61,205.47,143.55,205.07Zm.44,3.19H88.19q-.14.62-.24,1.2h56.2C144.1,209.07,144,208.67,144,208.26Zm.4,3.19H87.58c-.08.42-.15.82-.22,1.2h57.18Q144.48,212.08,144.39,211.45Zm.37,3.2H87c-.07.43-.12.83-.18,1.19h58C144.84,215.49,144.8,215.09,144.76,214.65Zm-58.12,3.19a1.07,1.07,0,0,0,0,.53c.27.27,36.16-.28,51.45-.53Z",
    style: {
      fill: "rgb(3, 4, 2)",
      opacity: 0.1,
      transformOrigin: "115.706px 181.426px"
    },
    className: "animable",
    id: "el4ixue8khkmc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.86,152.72c-3.9,5.35-23.9,27.46-24.64,29.51s3.89,6.58,3.81,7.43c-.3,3.46-7.77,26.48-10.76,24.14-3.94-3.08-20.62-25.14-18.26-34.69s41.31-32.48,47.49-34.47S116.71,147.44,112.86,152.72Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "89.1388px 179.073px"
    },
    id: "elud5pznh7hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15,172.85,85.79,156.9S98.5,148.56,107,145s12.69-1.58,4.92,9.41A192.94,192.94,0,0,1,97.15,172.85Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "100.905px 158.117px"
    },
    id: "el0gct2pnrrun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.15,155.86q2.7,3.13,5.25,6.4c.84,1.07,1.69,2.13,2.5,3.22s1.61,2.31,2.46,3.43c.06.08-.06.18-.12.1-.86-1-1.78-2-2.64-3.1s-1.74-2.2-2.6-3.3c-1.7-2.18-3.35-4.41-4.94-6.67C89,155.88,89.1,155.8,89.15,155.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.2089px 162.439px"
    },
    id: "elrzlzo2x2asj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,172.93c1.74-2.31,3.79-4.37,5.67-6.56s3.75-4.45,5.54-6.73c0,0,.13,0,.09.06-.83,1.19-1.64,2.39-2.51,3.55-.43.57-.88,1.13-1.34,1.69l.67-.55a25.64,25.64,0,0,1,2.13-1.44s.08,0,0,.06a24.16,24.16,0,0,1-2,1.66c-.5.38-1,.73-1.53,1.08l-.8,1A47.56,47.56,0,0,1,97.24,173C97.18,173.09,97.07,173,97.13,172.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.775px 166.339px"
    },
    id: "eletbvpvzsip9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,222.54c2.67-1.81-1-3.93-1-3.93s6,1.78,8-1.15-2.56-5.23-2.88-5.41c.32.1,5.88,1.58,7.62-1.57s-3.14-4.91-3.46-5c.33,0,4.66-.19,5.44-2.89,1.33-4.63-11.11-5.17-13.79-8,0,0,1.2-6.12,1.3-6.29a7,7,0,0,1-3.54,3c-2.69.76-5.11,1.2-6.2,2.49a3.54,3.54,0,0,0-.4,4.2s-3.4-.39-4.85,2.05c-.74,1.25.61,3.56.61,3.56a4.21,4.21,0,0,0-3.89,2c-.93,1.8.57,3.83.57,3.83s-2.72,1-3.07,3.16C70.84,216.92,85.33,226.4,91.05,222.54Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "88.1784px 205.872px"
    },
    id: "ellm6zjvhz4ba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.82,209.8s-.11,0-.07.07a30,30,0,0,0,15.5,8.88c.19,0,.33-.26.13-.34A61.5,61.5,0,0,1,74.82,209.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.6094px 214.275px"
    },
    id: "elxdz2s6xhme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,203.56a.06.06,0,0,0-.08.1,28.16,28.16,0,0,0,17.51,8.63c.23,0,.46-.2.19-.24C91,211.37,82.26,207,77.86,203.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.679px 207.918px"
    },
    id: "elprthrtaflq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,205.33c-6.52-.74-12.15-3.5-17.52-7.16-.07,0-.13.05-.09.11,2.14,2.51,5.81,4.49,8.8,5.79a17.24,17.24,0,0,0,8.78,1.49C100,205.55,100,205.35,99.87,205.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.1056px 201.902px"
    },
    id: "el8aapi72zm7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,209.43a4.17,4.17,0,0,1-1-4.25A3.16,3.16,0,0,1,75,203.62a5.32,5.32,0,0,1,2.55-.23,4.08,4.08,0,0,1-.07-4.62,3.12,3.12,0,0,1,2-1.05,9.89,9.89,0,0,1,2.65.1,3.62,3.62,0,0,1-.77-3.15,3.94,3.94,0,0,1,2.4-2.63,19,19,0,0,1,4.21-1,9.39,9.39,0,0,0,2.15-.59,4.06,4.06,0,0,0,1.79-1.6c.08-.12.08,0,0,.11a4.92,4.92,0,0,1-1.06,1.26,6.37,6.37,0,0,1-1.45.95,27.4,27.4,0,0,1-4,1.17,5.6,5.6,0,0,0-3,2,3.36,3.36,0,0,0-.12,3.52s0,.13-.09.12a9.81,9.81,0,0,0-2.37.28,3.2,3.2,0,0,0-1.66,1,4.3,4.3,0,0,0-.2,4.28,7,7,0,0,0-2.49.64,3.15,3.15,0,0,0-1.18,1.3,3.71,3.71,0,0,0,.39,3.87.11.11,0,0,1,0,.05h0a0,0,0,0,1,0,0s0,0,0,0h0s-.87.36-.91.36,0,0,0,0A6.14,6.14,0,0,1,74.45,209.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.6042px 199.28px"
    },
    id: "elbpzdebwclao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,152.51c-3.18,1.17-9.4-3.16-12.11-6.94-.18-.26-.36-11.51-.62-13.73-.06-.46,14.37,1.72,14.37,1.72a35.69,35.69,0,0,0-.32,8.7C125.45,142.58,127.16,151.39,124.09,152.51Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "118.64px 142.24px"
    },
    id: "eln8xg4fkbux8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,133.56s-.16.93-.29,2.31c-4,4.91-10.42,5.43-13.68,5.32-.11-3.49-.24-8-.4-9.35C111.3,131.39,125.73,133.56,125.73,133.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.545px 136.491px"
    },
    id: "elkil139hv62",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.42,107.87s-4.6,1.78-5.54,6.38,0,9.48.38,9.73S111.42,107.87,111.42,107.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.448px 115.926px"
    },
    id: "el5k4j57ift1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,113.81c1.18,5.07-2.4,19.26-6.16,22.22-5.44,4.3-13.88,4.18-17.42-2.25-3.42-6.23,1.58-24.63,5.73-27.28C118.25,102.61,128.23,106.31,130,113.81Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "117.756px 121.956px"
    },
    id: "el50l2om8vmrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,121.78s.07.06.06.1c-.2,1-.27,2.13.57,2.61,0,0,0,.06,0,.05C115.28,124.2,115.38,122.67,115.73,121.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.925px 123.161px"
    },
    id: "el558gdzo7gid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.78,120.9c1.61.15,1.18,3.35-.3,3.21S115.44,120.77,116.78,120.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.68px 122.505px"
    },
    id: "el0ienick3qnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,120.79s-.08,0-.09.08c-.09,1-.36,2.11-1.3,2.33,0,0,0,.06,0,.06C109.88,123.24,110.22,121.74,110.15,120.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.459px 122.025px"
    },
    id: "elo3z596oxetr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,119.64c-1.58-.32-2.11,2.86-.64,3.16S110.72,119.91,109.4,119.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.032px 121.219px"
    },
    id: "elotg9ei9xn2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,130.05c-.26.21-.53.51-.89.51a2.65,2.65,0,0,1-1.05-.34,0,0,0,0,0,0,0,1.32,1.32,0,0,0,1.21.65,1,1,0,0,0,.86-.81S115.55,130,115.51,130.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.605px 130.451px"
    },
    id: "el2bk9cs79c5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.88,125.49s-.42,1.44-.52,2.14a14.27,14.27,0,0,1,3.93,1.17c.29.14.33-.11,0-.37a6,6,0,0,0-3.26-1.32c0-.2.69-2.21.58-2.24A5.87,5.87,0,0,0,110,125c.78-3,2-5.92,2.78-9,0-.11-.13-.17-.18-.08a51.48,51.48,0,0,0-3.4,9.52C109.07,125.88,110.58,125.57,110.88,125.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.857px 122.358px"
    },
    id: "el3xh3qsmchf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,119.81c-.38-.24-.68-.53-1-.8s-.74-.52-.89-1a.65.65,0,0,1,.36-.73,1.64,1.64,0,0,1,1.64.37,2.4,2.4,0,0,1,1,1.45A.71.71,0,0,1,118,119.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.608px 118.57px"
    },
    id: "elx3m6slowuti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,116.12c.44-.07.84-.19,1.27-.3a2.08,2.08,0,0,0,1.24-.55.68.68,0,0,0,0-.82,1.67,1.67,0,0,0-1.65-.35,2.45,2.45,0,0,0-1.52.9A.72.72,0,0,0,108.7,116.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.632px 115.069px"
    },
    id: "elpou4ijkys5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64,125.93c-2.94-.29-1.34-13.26-1.34-13.26a18.82,18.82,0,0,1-5.63,1,25.51,25.51,0,0,1-5.73-.86c-.4-.15,4.91-1.65,4.91-1.65s-13.06,1.14-13.5-1.32c-.16-.85,2.27-8.59,13.11-8.1,8,.36,11.73,8.72,11.73,8.72s3.89,4.33,3.22,6.29C133.27,120.19,130.76,126.24,127.64,125.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "120.415px 113.83px"
    },
    id: "el1dc1za97egu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,126s3.65-4.36,5.66-3-1,7.85-3.58,8.56a2.53,2.53,0,0,1-3.25-1.65Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "128.433px 127.219px"
    },
    id: "el7qemnuard0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,124.82a0,0,0,0,1,0,.07,6.36,6.36,0,0,0-3.63,3.68,1.4,1.4,0,0,1,2.11-.2.06.06,0,0,1-.06.09,1.57,1.57,0,0,0-1.75.39,7.57,7.57,0,0,0-.93,1.31c-.1.15-.37,0-.29-.13v0C126.22,127.77,128.21,124.83,130.6,124.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.318px 127.521px"
    },
    id: "elyuoxrylsj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,185.56c8.12-6.27.36-38.1-4.36-49.82-1.39-3.45-23.44,3-22.41,6.87C153.69,164.5,165.68,192.43,174.57,185.56Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "162.936px 160.689px"
    },
    id: "elvtwimkmem3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.45,154.62l2.43,6c.83,2,1.64,4,2.54,6s1.77,3.93,2.69,5.88,1.94,3.86,2.94,5.78a51.36,51.36,0,0,1-3.45-5.51c-1-1.91-2-3.87-2.87-5.85s-1.67-4-2.39-6.06S152,156.73,151.45,154.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.75px 166.45px"
    },
    id: "elpqvprwsl6q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "162.058px 70.3838px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,91.35a5.71,5.71,0,1,1-6.19-5.2A5.71,5.71,0,0,1,150,91.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "144.311px 91.838px"
    },
    id: "elhoypasv2vud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,91.35a6,6,0,0,1-5.18,6.43,6,6,0,1,1-1-11.88A6,6,0,0,1,150,91.35Zm0,0a5.47,5.47,0,0,0-6.16-4.95,5.47,5.47,0,0,0,.94,10.89A5.47,5.47,0,0,0,150,91.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.83px 91.8969px"
    },
    id: "elta451u09t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,101.88a3.18,3.18,0,1,1-3.44-2.9A3.17,3.17,0,0,1,137.58,101.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "134.411px 102.148px"
    },
    id: "ellq2lf4tkyof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,101.88a3.43,3.43,0,1,1-3.46-3.15A3.46,3.46,0,0,1,137.58,101.88Zm0,0a2.93,2.93,0,0,0-3.42-2.65,2.94,2.94,0,1,0,3.42,2.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.161px 102.16px"
    },
    id: "elzrvx2x8upf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,64.79a16.69,16.69,0,0,1-14.54,18.57,16.51,16.51,0,0,1-8.5-1.19,14,14,0,0,1-22.25,0,11.61,11.61,0,0,1-1.88.39,11.34,11.34,0,0,1-10.65-17.78,16.68,16.68,0,0,1,22.45-24.13,14,14,0,0,1,24,3.81,8.73,8.73,0,0,1,1.8-.4A9.16,9.16,0,0,1,191,59.27,16.43,16.43,0,0,1,192.66,64.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.307px 61.5474px"
    },
    id: "elx3l7owsobpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,64.79a16.93,16.93,0,0,1-3.39,12.31,17.55,17.55,0,0,1-3.1,3.05,16.89,16.89,0,0,1-16.6,2.16l.16,0a14.17,14.17,0,0,1-11.25,5.64,14.32,14.32,0,0,1-6.33-1.45,14.71,14.71,0,0,1-5.05-4.12l.36.12a11.77,11.77,0,0,1-7.12-.1,11.65,11.65,0,0,1-5.77-4.21,12.64,12.64,0,0,1-1.65-3.23,12.15,12.15,0,0,1-.59-3.58,11.82,11.82,0,0,1,2.12-6.86l0,.56a16.87,16.87,0,0,1-3.67-11.32,17,17,0,0,1,26.67-13.37l-.44.06a14.27,14.27,0,0,1,13.41-5.08,14.22,14.22,0,0,1,11,9.07l-.13-.07a9.32,9.32,0,0,1,6,.08A9.19,9.19,0,0,1,191,59.28v0A16.33,16.33,0,0,1,192.66,64.79Zm0,0a16.36,16.36,0,0,0-1.7-5.51h0a9.08,9.08,0,0,0,.87-11.11,9.06,9.06,0,0,0-10.48-3.63l-.1,0,0-.1A14,14,0,0,0,177,38.64a13.71,13.71,0,0,0-6.58-2.88,13.9,13.9,0,0,0-7.11.8,13.7,13.7,0,0,0-5.71,4.26l-.19.24-.26-.18a16.29,16.29,0,0,0-21.89,23.56l.22.28-.21.29a10.87,10.87,0,0,0-2,6.31,11.63,11.63,0,0,0,.53,3.31,11.27,11.27,0,0,0,1.51,3,11,11,0,0,0,12,4.17l.23-.06.13.18a14,14,0,0,0,4.78,4,13.77,13.77,0,0,0,17.1-3.84l.07-.09.1,0a16.47,16.47,0,0,0,8.47,1.24,16.81,16.81,0,0,0,8-3.21,17.38,17.38,0,0,0,3.1-3,17.62,17.62,0,0,0,2.21-3.74A16.89,16.89,0,0,0,192.66,64.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.073px 61.5639px"
    },
    id: "el3k7nf6a9lkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.15,65.31a9.33,9.33,0,0,1,.64-3.56A5.87,5.87,0,0,1,167.46,59c.41-.25.9-.52,1.5-.83a12,12,0,0,0,1.73-1.11,6.48,6.48,0,0,0,1.44-1.52,3.51,3.51,0,0,0,.59-2,3.28,3.28,0,0,0-.33-1.5,3.38,3.38,0,0,0-.85-1.09,3.47,3.47,0,0,0-1.23-.66,4.7,4.7,0,0,0-1.43-.23,4,4,0,0,0-1.62.31,5.62,5.62,0,0,0-1.31.76,6.19,6.19,0,0,0-1,1.06,10.6,10.6,0,0,0-.79,1.11l-3.52-2.43a8,8,0,0,1,1.4-2.22A8.25,8.25,0,0,1,164,47a9.46,9.46,0,0,1,2.4-1,10.29,10.29,0,0,1,2.67-.34,10.83,10.83,0,0,1,3,.44,7.82,7.82,0,0,1,2.69,1.42A7.32,7.32,0,0,1,176.7,50a8.23,8.23,0,0,1,.74,3.62,7.87,7.87,0,0,1-.3,2.28,6.26,6.26,0,0,1-.87,1.8,7.67,7.67,0,0,1-1.33,1.46,14.43,14.43,0,0,1-1.74,1.25l-1.62.93a9.93,9.93,0,0,0-1.47,1A4.61,4.61,0,0,0,169,63.59a3.23,3.23,0,0,0-.43,1.72Zm.08,9.42V69.15h4.48v5.58Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "169.041px 60.1949px"
    },
    id: "elp3k8eumjy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,54.87a9,9,0,0,1,.1,3.61,5.83,5.83,0,0,1-2,3.24c-.35.32-.78.69-1.3,1.12a12.43,12.43,0,0,0-1.47,1.44,6.41,6.41,0,0,0-1.09,1.78,3.49,3.49,0,0,0-.16,2.08,3.17,3.17,0,0,0,.62,1.39,3.37,3.37,0,0,0,1.06.9,3.49,3.49,0,0,0,1.34.4,5,5,0,0,0,1.45-.08,4.07,4.07,0,0,0,1.52-.63,5.83,5.83,0,0,0,1.13-1,6.09,6.09,0,0,0,.81-1.25,11.52,11.52,0,0,0,.54-1.25l3.94,1.66a7.74,7.74,0,0,1-.91,2.46,8.38,8.38,0,0,1-1.6,2,9.48,9.48,0,0,1-2.14,1.48,10.19,10.19,0,0,1-2.54.88,10.43,10.43,0,0,1-3.06.19,7.56,7.56,0,0,1-2.92-.83,7.45,7.45,0,0,1-2.41-2,8.94,8.94,0,0,1-1.65-5.69,6.22,6.22,0,0,1,.48-1.93,7.48,7.48,0,0,1,1-1.7,14.79,14.79,0,0,1,1.44-1.59c.46-.42.93-.84,1.39-1.24A9.26,9.26,0,0,0,148.92,59a4.84,4.84,0,0,0,.81-1.45,3.27,3.27,0,0,0,.06-1.77Zm-2-9.2,1.15,5.46-4.39.92-1.15-5.46Z",
    style: {
      fill: "#DF2953",
      transformOrigin: "152.008px 60.4991px"
    },
    id: "elr56iuu04tv",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo2);
export default __webpack_public_path__ + "static/media/WhatWeDo2.11d1f144e3fdfd81ac0658539ecc709c.svg";
export { ForwardRef as ReactComponent };